<template>
	<div class="center">
		<div class="cardGrid">
			<h1 class="teamName">{{ team }}</h1>
			<div>
				<div class="pictures" :style="{'background-image': 'url(' + require('../assets/i' + noSpaces + '.png') + ')'}">
					<img class="playerPic" alt="C" :src="image"/>
					<!-- <img class="teamLogo" alt="logo" :src="require('../assets/i' + team + '.png')" /> -->
				</div>	
				<div class="information">
					<div>
						<p class="firstName">{{ firstname }}</p>
						<p class="lastName">{{ lastname }}</p>
					</diV>
					<div>
						<p class="position">{{ position }}</p>
						<p class="jerseynumber">#{{ jerseynumber}}</p>
					</div>
				</div>
				<div class="stats">
					<p>Points:</p><p v-show="showPoints">{{ points }}</p>
				</div>		
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Center',
		props: {
			points: String,
			firstname: String,
			lastname: String,
			team: String,
			position: String,
			image: String,
			jerseynumber: String,
			shown: Boolean
		},
		computed: {
			noSpaces: function () {
				if (this.team == "Trail Blazers") {
					return this.team.replace(/\s+/g, '');
				}else {
					return this.team
				}
			},
			showPoints: function () {
				if (this.shown == true) {
					return true
				}else {
					return false
				}
			}
		}
	}
</script>

<style scoped>

.cardGrid {
	/* height: 330px; */
	width: 280px;
	display: grid;
	grid-template-columns: 39px 205px
}

.teamName {
	transform: rotate(-90deg);
	width: 300px;
	height: 300px
}

.pictures {
	background-position-x: -45px;
	background-repeat: no-repeat;
	background-position-y: -8px;
	background-size: contain
}

.information {
	display: grid;
	grid-template-columns: auto auto	
}

</style>
